/**
 * @generated SignedSource<<37372e88d33b80eeaed0437d6bdd6e38>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewNew_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewNew_fragmentRef";
};
export type originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewNew_fragmentRef$key = {
  readonly " $data"?: originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewNew_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewNew_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewNew_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraTimeTrackingField"
};

(node as any).hash = "da8c6f0e72eccd42e5adca496d2591db";

export default node;
